// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202606180135/js/" + chunkId + "." + {"44":"3c023e45","225":"2b3d6d9d","481":"06da9e42","486":"80cd5e0c","770":"96d544c4"}[chunkId] + ".0.7519969955201532.chunk.js";
};